import styled, { StyledComponent } from "styled-components";

const FieldSet: StyledComponent<"fieldset", any, {}, never> = styled.fieldset`
  border: medium none;
  margin: 0 0 10px;
  min-width: 100%;
  padding: 0;
  width: 100%;
`;

const Input: any = styled.input`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 0px;
  padding: 5px;
  &:hover {
    transition: border-color 0.3s ease-in-out;
    border: 1px solid #aaa;
  }
  &:focus {
    outline: 0;
    border: 1px solid #aaa;
  }
  :first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  :last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

const xFix = styled.div`
  display: flex;
  font-size: 14px;
  font-weight: 400;
  color: #555;
  text-align: center;
  background-color: #eee;
  border: 1px solid #ccc;
  white-space: nowrap;
  align-items: center;
  padding: 0 15px;
`;

const Prefix = styled(xFix)`
  border-radius: 4px 0px 0px 4px;
  border-right: 0;
`;

const Suffix = styled(xFix)`
  border-radius: 0px 4px 4px 0px;
  border-left: 0;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const Error = styled.div`
  color: #ff0000;
`;

const Required = styled.span`
  color: #ff0000;
`;

const Info = styled.div`

`;

export { FieldSet, Input, Error, Prefix, Suffix, InputWrapper, Info, Required };
